/**
 * Directive for dealing with insurance
 */
angular.module('bookingApp')
    .directive('skInsurance', function(){
        return {
            require: 'ngModel',
            scope: {
                coverPrice: '=',
                modelValue: '=',
                showError: '=',
                errorMessage: '='
            },
            link: function($scope, elem, attrs, ctrl){
                // custom validator - will stop lead guest screen from proceeding
                ctrl.$parsers.unshift(function(value){
                    var valid = true;
                    if(value.chosen === null){
                        valid = false;
                        ctrl.$setValidity('invalidChoice', false);
                    } else {
                        valid = true;
                        ctrl.$setValidity('invalidChoice', true);
                    }
                    return valid ? valid : undefined;
                });
            },
            controller: function($scope, $http){
                $scope.insuranceChecked = null;
                if($scope.modelValue.chosen === true){
                    $scope.insuranceChecked = 'yes';
                }
                if($scope.modelValue.chosen === false){
                    $scope.insuranceChecked = 'no';
                }
                $scope.toggleInsuranceTo = function($to){
                    $scope.insuranceChecked = $to;
                    $scope.modelValue.chosen = $to === 'yes' ? true : false;
                    
                };
            },
            template: '<div>' +
                '<div id="insurance-error" ng-if="showError">{{errorMessage}}</div>' +
                '<h1>Consider Cancellation Cover</h1>' +
                '<div id="insurancePrice" class="text-center">{{coverPrice}} Total Cost</div>' +
                '<div id="insurance-logo" class="text-center">' +
                    '<img src="/albatross/static/images/logos/chubb_logo_purple.jpg" />' +
                '</div>' +
                '<div id="insuranceSummary">' +
                    '<h5 class="text-center">Summary of Key Benefits and Exclusion Examples*</h5>' +
                '</div>' +
                '<div id="cover-tiles">' +
                    '<div class="cover-tile">' +
                        '<div class="col-xs-12">' +
                            '<p><strong>Cancellation & Loss of Deposits Cover</strong> - up to a maximum of $5,000 NZD</p>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div>' +
                    '<p class="text-center">Like all insurance policies, some exclusions apply to this policy. For example if you change your mind and decide to cancel your booking, you will not be covered for any associated costs.</p>' +
                '</div>' +
                '<div>' +
                    '<p class="text-center"><a href="http://docs.chubbtravelinsurance.com/aceStatic/Document/NZ/PolicyWording_Seekom.pdf" target="_blank" rel="noopener noreferrer">Click here</a> to review the full terms, conditions, limitations and exclusions that apply.</p>' +
                '</div>' +
                '<div id="insurance-checkboxes" ng-if="!showError">' +
                    '<button type="button" class="insurance-checkbox checkbox-yes btn btn-success col-xs-12" ng-click="toggleInsuranceTo(\'yes\')">' +
                        '<div class="col-xs-2">' +
                            '<input ng-true-value="\'yes\'" ng-false-value="\'no\'" value="yes" ng-model="insuranceChecked" type="checkbox" name="insuranceYes" id="insuranceYes">' +
                        '</div>' +
                        '<label class="col-xs-10"><strong>YES</strong>, add Cancellation Cover <br />to my booking for {{coverPrice}}</label>' +
                    '</button>' +
                    '<button type="button" class="insurance-checkbox checkbox-no btn col-xs-12" ng-click="toggleInsuranceTo(\'no\')">' +
                        '<div class="col-xs-2">' +
                            '<input ng-true-value="\'no\'" ng-false-value="\'yes\'" value="no" ng-model="insuranceChecked" type="checkbox" name="insuranceNo" id="insuranceNo">' +
                        '</div>' +
                        '<label class="col-xs-10"><strong>NO</strong>, I don\'t need Cancellation Cover <br />for my booking</label>' +
                    '</button>' +
                    '<div class="insurance-error-msg">Please ensure you select YES or NO for insurance</div>' +
                '</div>' +
                '<div id="insurance-details">' +
                    '<p class="text-center">*Seekom (Company Number 1239626) promotes this product and Chubb Insurance New Zealand Limited (Company Number 104656, FSP No. 35924) (Chubb) insures this product. Seekom and Chubb provide general/class advice only and do not consider your objectives, financial situation or needs. Please ensure that this product is right for you by reading the <a href="http://www.acegroup.com/nz-en/assets/ace-nz-qfe-disclosure-statement.pdf" target="_blank" rel="noopener noreferrer">Qualifying Financial Entity Disclosure Statement (QFEDS)</a> and <a href="http://docs.chubbtravelinsurance.com/aceStatic/Document/NZ/PolicyWording_Seekom.pdf" target="_blank">Policy Wording</a> and note that terms, conditions, limitations and exclusions apply. You must be 18 years old or over to purchase Cancellation Cover.</p>' +
                '</div>' +
            '</div>'
        }
    });